import Api from './api';

const slug = 'v1/certificates';

export default {
  verifyCertificate(certificateId) {
    return new Promise((resolve, reject) => {
      Api.get(`/cert-verifier/${certificateId}`)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  getCertificates(params) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/`, { params })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  createCertificate(certificate) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/`, certificate)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  downloadCertificate(certificate) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/${certificate._id}/pdf-download`, { responseType: 'blob' })
        .then(res => resolve(res))
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateCertificate(certificate) {
    return new Promise((resolve, reject) => {
      Api.patch(`/${slug}/${certificate._id}`, certificate)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteCertificate(certificate) {
    return new Promise((resolve, reject) => {
      Api.delete(`/${slug}/${certificate._id}`)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
};
